import React from "react";
import { styled } from "styled-components";

import { ConfirmField, DateField, InputField, NHSNumberField, RadioGroupField } from "affinityForm/fields";
import { Grid } from "affinityUI/elements/grid";
import { DataEntryGroup } from "affinityUI/form/components";

export const Separator = styled.hr`
  border-top: ${(props) => props.theme.colours.borders};
  margin: 0 0 2rem 0;
`;

const DEFAULT_COLS = { xs: [1], lg: [1, 1] };

export const SectionPatientInfo: React.FC = () => (
  <DataEntryGroup title="Patient information" id="info">
    <NHSNumberField name="nhsNumber" confirmLabel="Confirm NHS number">
      NHS number
    </NHSNumberField>
    <ConfirmField name="hospitalNumber" confirmLabel="Confirm hospital number">
      Hospital number
    </ConfirmField>
    <Separator />
    <Grid $cols={DEFAULT_COLS}>
      <InputField name="firstName">First name</InputField>
      <InputField name="lastName">Last name</InputField>
    </Grid>
    <Grid $cols={DEFAULT_COLS}>
      <DateField name="dateOfBirth">Date of birth</DateField>
    </Grid>
    <RadioGroupField
      name="sex"
      options={[
        { id: "Female", label: "Female" },
        { id: "Male", label: "Male" },
      ]}
    >
      Sex
    </RadioGroupField>
  </DataEntryGroup>
);
